import { RcAlert, RcPage, RcSection } from "@financeone/core-ui";
import React from "react";
import { Link } from "react-router-dom";
import RouteTable from "../../manifold/RouteTable";
import "./Dashboard.scss";

const Dashboard: React.FunctionComponent = () => {
    return (
        <>
            <div className="dashboard-backdrop">
                <div className="dashboard-backdrop-fill">
                    <div className="inner">
                        <h1>Referral API</h1>
                        <p>
                            <span>Finance One</span>
                            <span>A smart road to finance</span>
                        </p>
                    </div>
                </div>
            </div>
            <RcPage>
                <RcAlert icon="Information" title="This API Requires an API Key" variant="primary">
                    <p>
                        All requests made to the Finance One API must provide a valid API key in the HTTP headers. API keys are supplied to accredited brokerage groups upon completion of the application process. For more information, please contact your local
                        BDM.
                    </p>
                </RcAlert>
                <RcAlert icon="Alert" title="Disclaimer" variant="warning">
                    <p>
                        The content of this document is protected by copyright. Except as permitted by copyright law, you may not reproduce any of the content of this document without the permission of the copyright owner, Fin One Pty Ltd (trading as Finance
                        One).
                    </p>
                    <p>Finance One permits approved introducers to access the Finance One API to use and communicate content in which Finance One owns copyright for the purpose of submitting loan applications to Finance One by their organisation.</p>

                    <p>We may change the content of this document from time to time. Please check before re-using any content from this document.</p>
                </RcAlert>
                <RcSection title="About the API">
                    <p>
                        The Finance One API has been built with the purpose of providing an alternative method of application submission for accredited brokerage groups. Developers can make use of this API to integrate the Finance One submission process with
                        their existing systems, using the provided endpoints to retrieve the necessary data required for a valid submission, and then submit applications programmatically.
                    </p>
                </RcSection>
                <RcSection title="Future Updates">
                    <p>
                        As Finance One is constantly evolving and improving it's application structures and systems, there is a high chance that the models, validators, and endpoints detailed in this document will be subject to changes in the future. Finance
                        One will endeavour to provide all API users with at least 30 days notice before deploying any such changes, to give all users time to update their relevant systems.
                    </p>
                    <p>
                        The API also makes use of several dynamic fields across our application structures for fields that are subject to frequent updates. These fields have corresponding endpoints which can be used to retrieve an up to date list of currently
                        accepted values. It is highly recommended that all users make use of these endpoints in their integrations, to avoid interruptions caused by changing fields. For more details on these dynamic fields, please refer to the
                        <Link to={RouteTable.ProductSectorTypes.ReferralModel}>Referral Model</Link> section of this documentation.
                    </p>
                </RcSection>
                <RcSection title="Sectors For Referral Model">
                    <p>
                        The Finance One API currently accepts some of the following sections before referring accepting a Referral. Each field type is composed of a series of sections, some specifically made for certain types of applicants, and others generic
                        and shared between the application structures.
                    </p>
                    <ul>
                        <li>
                            <Link to={RouteTable.ProductSectorTypes.ReferralModel}>ReferralModel</Link> - Used for Referral applications where 1-2 individual/s are applying for finance.
                        </li>
                    </ul>
                </RcSection>
                <RcSection title="Application Validation">
                    <p>When submitting an application to its relevant submission endpoint, it will be evaluated by two stages of validation. If the application is found to be invalid at either stage, a list of errors to be rectified will be returned.</p>
                    <p>The first stage is simple form validation, making sure that all the models required fields have been provided, and that these fields are using the expected data types.</p>
                    <p>
                        Once simple validation has been run successfully, the application will be passed through a series of complex validators. These validators extend beyond the simple form validation, ensuring that the submitted application adheres to our
                        business rules, and that all information required to make a reasonable assessment has been provided.
                    </p>
                    <p>The details of each complex validator can be found in the Complex Validation section of this documentation.</p>
                </RcSection>
            </RcPage>
        </>
    );
};

export default Dashboard;
